// extracted by mini-css-extract-plugin
export default {"wrapper":"pages-style-module__wrapper--DgCGd","content":"pages-style-module__content--gKrhn","loader":"pages-style-module__loader--wT0VT"};